// import http from "../../../core/utils/apis/skillApi";

import http from "../../../core/utils/apis/api";

const login = async (loginData) => {
    try {
        const response = await http({
            method: "POST",
            url: `/auth/login`,
            data: loginData
        });
        return response;
    } catch (e) {
        throw e;
    }
};

const loginService = {
    login
};

export default loginService;
